import {ICellRendererParams} from '../types/AgGridTypes';

export const getStylesToRender = (cellRendererProps: ICellRendererParams) => {
  const {data, column} = cellRendererProps;

  if (column) {
    return data[column.getColId()]?.style;
  }
};
